module.exports = __webpack_public_path__ + "3533e8bdddfa537879fb99e39e32ce56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_goods_5.jpg
// module id = 211
// module chunks = 1